// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"594":"about","962":"home"}[chunkId] || chunkId) + "." + {"190":"5925ee15","294":"f692624e","386":"2c3fa780","483":"7e52788c","594":"1bbb6feb","611":"7e52788c","663":"ac272514","754":"25c30960","847":"2c3fa780","962":"17398da6"}[chunkId] + ".css";
};